import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { Typography } from "@mui/material";
import CommonButton from "@/views/CommonComponent/CommonButton";
import {
  SignInContentsBox,
  SignInRoot,
  SignInProgressBarContainer,
  SignInProgressTrack,
  SignInProgressFill,
} from "./Styled/SignInStyled";
import TitleBox from '../CommonComponent/TitleBox'
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import CommonDialog from "@/views/CommonComponent/CommonDialog";
import { Icon } from '@iconify/react';
import CheckedComponent from "./CheckedComponent";
import { c } from '../../theme/colorUtils';

const TermsProgressBar = React.memo(function TermsProgressBar(props) {
  const { percent } = props;

  return (
    <SignInProgressBarContainer aria-label="회원가입 진행률">
      <SignInProgressTrack role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
        <SignInProgressFill percent={percent} />
      </SignInProgressTrack>
    </SignInProgressBarContainer>
  );
});

function SignInTerms(props) {
  const { intl, authStore } = props;
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const handleClick = async () => {
    history.push("/signin/nickname");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const moveLoginPage = () => {
    authStore.doLogout(() => history.push("/"));
  };

  const isButtonDisabled = () => {
    return !(authStore.termsOfAge && authStore.termsOfUse && authStore.termsOfPrivacy);
  };

  return (
    <SignInRoot>
      <TitleBox
        title={intl.formatMessage({ id: "service_terms" })} /* 서비스 이용약관 */
        subtitle={intl.formatMessage({ id: "signInTerms_text" })} /* 해당 서비스를 이용하려면 약관의 동의가 필요해요 */
        onBack={handleClickOpen}
      >
      </TitleBox>
      <TermsProgressBar percent={33} />
       <SignInContentsBox className="Terms">
        <CheckedComponent/>
        <CommonButton
          text={intl.formatMessage({ id: "dialog_nextButton" })} /* 다음 */
          background={c.primary}
          color={c.text01}
          disabled={isButtonDisabled()}
          onClick={handleClick}
        />
       </SignInContentsBox>
      <CommonDialog
        open={open}
        title={intl.formatMessage({ id: "signInfo_DialogTitle" })} /* 약관 동의 */
        subText={<pre>{intl.formatMessage({ id: "signIn_DialogSubText" })}</pre>}
        onClick1={moveLoginPage}
        onClick2={handleClickClose}
        onClose={() => {}} // 배경 클릭 시 아무 동작하지 않도록 설정
        LeftButtonText={intl.formatMessage({ id: "dialog_YesButton" })}
        RightButtonText={intl.formatMessage({ id: "dialog_NoButton" })}
      />
    </SignInRoot>
  );
}

export default injectIntl(inject("authStore")(observer(SignInTerms)));
